
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 15.833c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 01-.49-1.176V5.833c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49h8.333c.459 0 .851.164 1.177.49.327.327.49.719.49 1.177v8.334c0 .458-.163.85-.49 1.177-.326.326-.718.49-1.177.49H2.5zm0-3.041a8.151 8.151 0 011.958-.834 8.153 8.153 0 012.209-.291c.777 0 1.514.097 2.208.291a8.15 8.15 0 011.958.834V5.833H2.5v6.959zm4.167-1.75c-.64 0-1.18-.223-1.625-.667a2.211 2.211 0 01-.667-1.625c0-.639.222-1.18.667-1.625a2.211 2.211 0 011.625-.667c.639 0 1.18.223 1.625.667.444.444.666.986.666 1.625s-.222 1.18-.666 1.625a2.211 2.211 0 01-1.625.667zm7.5 4.791V4.167h1.666v11.666h-1.666zm3.333 0V4.167h1.667v11.666H17.5z"}})])
          )
        }
      }
    